import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
//-----------------------|| GUEST GUARD ||-----------------------//


/**
 * GuestGuard component is responsible for enforcing the
 * authentication logic for guest users. It checks if the user is logged in
 * and redirects them to the default path if they are.
 *
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The child components.
 * @return {React.ReactNode} The rendered component.
 */
const GuestGuard = ({ children }) => {
    /**
     * The redux account state.
     * @type {Object}
     */
    const account = useSelector((state) => state.account);
    const { isLoggedIn, user, token } = account;
    const location = useLocation();

    console.log('session info :',isLoggedIn)
            
    /**
     * If the user is logged in, redirects them to the default path.
     * @return {React.ReactNode} The Navigate component.
     */
    if (isLoggedIn) {
        console.log('inside the login')
        return <Navigate to={config.defaultPath} />;
    }

    return children;
};

/**
 * The prop types for the GuestGuard component.
 * @type {Object}
 */
GuestGuard.propTypes = {
    children: PropTypes.node
};

export default GuestGuard;
